import { ContextActions } from 'utils/constants';
import { i18nCaReasonCodes } from 'models/caReasonCodes';

const {
  CA_EAI_CREATE_PARTY,
  CA_EAI_EDIT_PARTY,
  CA_EAI_DELETE_PARTY,
  CA_EAI_CREATE_MEMBER_ACCOUNT,
  CA_EAI_EDIT_MEMBER_ACCOUNT,
  CA_EAI_EDIT_MARKET_PARTICIPANT,
  CA_EAI_CHANGE_MEMBER_ACCOUNT_SUBSCRIPTION_LEVEL,
  CA_EAI_DISABLE_MEMBER_ACCOUNT,
  CA_EAI_RESTORE_MEMBER_ACCOUNT,
  CA_EAI_CREATE_MARKET_PARTICIPANT_MEMBER_ACCOUNT,
  CA_EAI_CREATE_SERVICE_PROVIDER_MEMBER_ACCOUNT,
  CA_EAI_UPLOAD_MARKET_PARTICIPANT_CREDENTIALS,
  CA_EAI_WITHDRAW_MARKET_PARTICIPANT_CREDENTIALS,
  CA_EAI_UPLOAD_OKTE_ISZO_CREDENTIALS,
  CA_EAI_UPLOAD_OKTE_ISOT_CREDENTIALS,
  CA_EAI_UPLOAD_DAMAS_CREDENTIALS,
  CA_EAI_CREATE_USER,
  CA_EAI_RESET_USER_PASSWORD,
  CA_EAI_BLOCK_USER,
  CA_EAI_UNBLOCK_USER,
  CA_EAI_EDIT_USER_USERNAME,
  CA_EAI_USER_ASSIGN_MEMBER_ACCOUNT,
  CA_EAI_USER_UNASSIGN_MEMBER_ACCOUNT,
  CA_EAI_USER_ASSIGN_ROLE,
  CA_EAI_USER_UNASSIGN_ROLE,
  CA_EAI_EDIT_DELIVERY_POINT_ASSIGNMENT,
  CA_EAI_CREATE_DELIVERY_POINT,
  CA_EAI_EDIT_DELIVERY_POINT_GDS,
  CA_EAI_EDIT_BALANCE_GROUP,
  CA_EAI_LIST_BALANCE_GROUP_DELIVERY_POINTS,
  CA_EAI_EDIT_DEVICE,
  CA_EAI_REMOVE_DEVICE,
  CA_EAI_CHANGE_DEVICE_GDS,
  CA_EAI_EDIT_DEVICE_CHARACTERISTICS,
  CA_EAI_CREATE_DEVICE_CHARACTERISTIC_GROUP,
  CA_EAI_DELETE_DEVICE_CHARACTERISTIC_GROUP,
  CA_EAI_CREATE_DEVICE,
  CA_EAI_CREATE_DELIVERY_CONTRACT,
  CA_EAI_EDIT_BALANCE_GROUP_CHARACTERISTIC
} = ContextActions.EAI;

const {
  CA_DISP_CREATE_DEVICE_PRODUCTION_PLAN,
  CA_DISP_EDIT_DEVICE_PRODUCTION_PLAN,
  CA_DISP_CONFIRM_DEVICE_PRODUCTION_PLAN,
  CA_DISP_PROPAGATE_DEVICE_PRODUCTION_PLAN,
  CA_DISP_COPY_DEVICE_PRODUCTION_PLAN,
  CA_DISP_CREATE_DAILY_DIAGRAM,
  CA_DISP_EDIT_DAILY_DIAGRAM,
  CA_DISP_VALIDATE_DAILY_DIAGRAM,
  CA_DISP_ACCEPT_DAILY_DIAGRAM,
  CA_DISP_EXPORT_DAILY_DIAGRAM,
  CA_DISP_SUBMIT_DAILY_DIAGRAM_REVISION,
  CA_DISP_CREATE_OPERATION_EVENT,
  CA_DISP_EDIT_OPERATION_EVENT,
  CA_DISP_CANCEL_OPERATION_EVENT,
  CA_DISP_DELETE_OPERATION_EVENT,
  CA_DISP_ACCEPT_RESERVED_CAPACITY_GUARDING_ACTION,
  CA_DISP_REJECT_RESERVED_CAPACITY_GUARDING_ACTION
} = ContextActions.DISPATCHER;

export const caReasonsCodesSK: i18nCaReasonCodes = {
  /* COMMON */
  UNRESOLVABLE_MARKET_PARTICIPANT_CONTEXT_FOR_SERVICE_PROVIDER:
    'S daným oprávnením nie je možné operáciu realizovať pod účtom pokystovateľa služby',
  /* COMMON */

  /* SUBJECTS*/
  [CA_EAI_CREATE_PARTY]: {
    PARTY_NAME_ALREADY_EXISTS: 'Názov subjektu už v systéme existuje',
    PARTY_IDENTIFIER_ALREADY_EXISTS: 'RČ/IČO už v systéme existuje'
  },
  [CA_EAI_EDIT_PARTY]: {
    EDIT_PARTY_NOT_ALLOWED: 'Nemáte právo editovať zvolený subjekt'
  },
  [CA_EAI_DELETE_PARTY]: {
    EDIT_PARTY_NOT_ALLOWED: 'Nemáte právo editovať zvolený subjekt',
    ACTIVE_EMS_MEMBER_ACCOUNT_FOUND_FOR_PARTY:
      'Subjekt nie je možné zmazať pretože má aktívne účty subjektu',
    ACTIVE_DELIVERY_CONTRACT_FOUND_FOR_PARTY:
      'Subjekt nie je možné zmazať pretože je zmluvnou stranou v aktívnom kontrakte'
  },
  [CA_EAI_CREATE_MEMBER_ACCOUNT]: {
    MEMBER_ACCOUNT_CREATE_FOR_PARTY_NOT_ALLOWED:
      'Nemáte právo vytvoriť účet subjektu pre zvolený subjekt',
    ALL_MEMBER_ACCOUNTS_CREATED: 'Všetky účty subjektov už boli vytvorené'
  },
  [CA_EAI_EDIT_MEMBER_ACCOUNT]: {
    EDIT_MEMBER_ACCOUNT_NOT_ALLOWED:
      'Nemáte právo editovať účet subjektu pre zvolený subjekt'
  },
  [CA_EAI_EDIT_MARKET_PARTICIPANT]: {
    EDIT_MARKET_PARTICIPANT_NOT_ALLOWED:
      'Nemáte právo pre daný subjekt editovať účastníka trhu',
    MARKET_PARTICIPANT_EIC_ALREADY_EXISTS:
      'EIC účastníka trhu už v systéme existuje'
  },
  [CA_EAI_CHANGE_MEMBER_ACCOUNT_SUBSCRIPTION_LEVEL]: {
    CHANGE_SUBSCRIPTION_LEVEL_T_NOT_ALLOWED:
      'Nemáte právo meniť úrovne služby pre daný subjekt',
    MEMBER_ACCOUNT_TYPE_NOT_ALLOWED:
      'Nemáte právo meniť úrovne služby pre daný účet subjektu',
    INCORRECT_MEMBER_ACCOUNT_STATUS:
      'Údaje neaktívneho účtu subjektu nie je možné editovať.'
  },
  [CA_EAI_DISABLE_MEMBER_ACCOUNT]: {
    DISABLE_MEMBER_ACCOUNT_NOT_ALLOWED:
      'Nemáte právo zneplatniť účet subjektu pre daný subjekt',
    INCORRECT_MEMBER_ACCOUNT_STATUS:
      'Daný účet subjektu nie je v stave “aktívny“'
  },
  [CA_EAI_RESTORE_MEMBER_ACCOUNT]: {
    RESTORE_MEMBER_ACCOUNT_NOT_ALLOWED:
      'Nemáte právo obnoviť účet subjektu pre daný subjekt',
    INCORRECT_MEMBER_ACCOUNT_STATUS:
      'Daný účet subjektu musí byť v stave “neaktívny“ alebo “blokovaný“'
  },
  [CA_EAI_CREATE_MARKET_PARTICIPANT_MEMBER_ACCOUNT]: {
    CREATE_MEMBER_ACCOUNT_NOT_ALLOWED:
      'Nemáte právo vytvoriť účet účastníka trhu pre daný subjekt',
    ACCOUNT_ALREADY_EXISTS: 'Už existuje účet subjektu v role “Účastník trhu“'
  },
  [CA_EAI_CREATE_SERVICE_PROVIDER_MEMBER_ACCOUNT]: {
    CREATE_MEMBER_ACCOUNT_NOT_ALLOWED:
      'Nemáte právo vytvoriť účet poskytovateľa služby pre daný subjekt',
    ACCOUNT_ALREADY_EXISTS:
      'Už existuje účet subjektu v role “Poskytovateľ služby“'
  },
  [CA_EAI_UPLOAD_MARKET_PARTICIPANT_CREDENTIALS]: {
    UPLOAD_MARKET_PARTICIPANT_CREDENTIALS_NOT_ALLOWED:
      'Nemáte právo nahrať prístupy k externým službám pre daný účet účastníka trhu',
    CERTIFICATE_HAS_BAD_CONTENT_TYPE:
      'Cetritikát nie je podporovaného typu X.509'
  },
  [CA_EAI_WITHDRAW_MARKET_PARTICIPANT_CREDENTIALS]: {
    WITHDRAW_MARKET_PARTICIPANT_CREDENTIALS_NOT_ALLOWED:
      'Nemáte právo odobrať prístupy k externým službám pre daný účet účastníka trhu'
  },
  [CA_EAI_UPLOAD_OKTE_ISZO_CREDENTIALS]: {
    CREDENTIALS_ALREADY_EXIST:
      'OKTE ISZO prihlasovacie údaje už existujú pre daného účastníka trhu',
    UPLOAD_TO_MARKET_PARTICIPANT_NOT_ALLOWED:
      'Nemáte právo nahrať prístupy k externým službám pre daný účet účastníka trhu'
  },
  [CA_EAI_UPLOAD_OKTE_ISOT_CREDENTIALS]: {
    UPLOAD_TO_MARKET_PARTICIPANT_NOT_ALLOWED:
      'Nemáte právo nahrať prístupy k externým službám pre daný účet účastníka trhu',
    CREDENTIALS_ALREADY_EXIST:
      'OKTE ISOT prihlasovacie údaje už existujú pre daného účastníka trhu'
  },
  [CA_EAI_UPLOAD_DAMAS_CREDENTIALS]: {
    UPLOAD_TO_MARKET_PARTICIPANT_NOT_ALLOWED:
      'Nemáte právo nahrať prístupy k externým službám pre daný účet účastníka trhu',
    CREDENTIALS_ALREADY_EXIST:
      'DAMAS prihlasovacie údaje už existujú pre daného účastníka trhu'
  },
  /* SUBJECTS */

  /* USERS */
  [CA_EAI_CREATE_USER]: {
    USER_EMAIL_ALREADY_EXISTS: 'Zadaná e-mailová adresa už v systéme existuje'
  },
  [CA_EAI_RESET_USER_PASSWORD]: {
    INCORRECT_USER_STATUS: 'Používateľ musí byť aktívny'
  },
  [CA_EAI_BLOCK_USER]: {
    INCORRECT_USER_STATUS: 'Používateľ musí byť aktívny'
  },
  [CA_EAI_UNBLOCK_USER]: {
    INCORRECT_USER_STATUS: 'Používateľ musí byť neaktívny'
  },
  [CA_EAI_EDIT_USER_USERNAME]: {
    USER_EMAIL_ALREADY_EXISTS: 'Zadaná e-mailová adresa už v systéme existuje'
  },
  [CA_EAI_USER_ASSIGN_MEMBER_ACCOUNT]: {
    USER_EDIT_NOT_ALLOWED: 'Nemáte právo priradiť daného používateľa',
    ASSIGNMENT_TO_CHOSEN_MEMBER_ACC_NOT_ALLOWED:
      'Nemáte právo priraďovať k danému účtu subjektu'
  },
  [CA_EAI_USER_UNASSIGN_MEMBER_ACCOUNT]: {
    USER_EDIT_NOT_ALLOWED: 'Nemáte právo priradiť daného používateľa',
    UNASSIGNMENT_FROM_CHOSEN_MEMBER_ACC_NOT_ALLOWED:
      'Nemáte právo priraďovať k danému účtu subjektu',
    CANNOT_UNASSIGN_MEMBER_ACC_WITH_CURRENTLY_ASSIGNED_ROLES:
      'Nemáte právo odobrať daného používateľa z účtu subjektu. Používateľ má rolu, ktorú nemáte právo odobrať.'
  },
  [CA_EAI_USER_ASSIGN_ROLE]: {
    USER_EDIT_NOT_ALLOWED: 'Nemáte právo priradiť daného používateľa',
    CANNOT_ASSIGN_REQUISITE_ROLE: 'Nemáte právo priradiť danú rolu'
  },
  [CA_EAI_USER_UNASSIGN_ROLE]: {
    CANNOT_UNASSIGN_REQUISITE_ROLE: 'Nemáte právo odobrať danú rolu'
  },
  /* USERS */

  /* DELIVERY POINT */
  [CA_EAI_EDIT_DELIVERY_POINT_ASSIGNMENT]: {
    DELIVERY_POINT_ASSIGNMENT_VALIDITY_CONFLICT:
      'Priradenie odberného miesta je v konfilte s iným priradením.',
    GDS_WITH_INSTALLED_DEVICES_DEREGISTRATION_CONFLICT:
      'GDS pri odregistrácií nesmie mať nainštalované zariadenia'
  },
  [CA_EAI_CREATE_DELIVERY_POINT]: {
    DELIVERY_POINT_EIC_ALREADY_EXISTS:
      'Odberné miesto s daným EIC už v systéme existuje.'
  },
  [CA_EAI_EDIT_DELIVERY_POINT_GDS]: {
    GDS_WITH_INSTALLED_DEVICES_DEREGISTRATION_CONFLICT:
      'GDS pri odregistrácií nesmie mať nainštalované zariadenia.'
  },
  /* DELIVERY POINT */

  /* BALANCE GROUPS */
  [CA_EAI_EDIT_BALANCE_GROUP]: {
    EDIT_BALANCE_GROUP_NOT_ALLOWED:
      'Nemáte oprávnenie upravovať údaje tejto bilančnej skupiny.'
  },
  [CA_EAI_LIST_BALANCE_GROUP_DELIVERY_POINTS]: {
    LIST_BALANCE_GROUP_DELIVERY_POINTS_NOT_ALLOWED:
      'Nemáte oprávnenie zobraziť odberné miesta tejto bilančnej skupiny.'
  },
  [CA_EAI_EDIT_BALANCE_GROUP_CHARACTERISTIC]: {
    EDIT_BALANCE_GROUP_CHARACTERISTIC_NOT_ALLOWED:
      'Nemáte právo upravovať charakteristiky tejto bilančnej skupiny.'
  },
  /* BALANCE GROUPS */

  /* DEVICES */
  [CA_EAI_EDIT_DEVICE]: {
    EDIT_DEVICE_NOT_ALLOWED: 'Nemáte právo editovať dané zariadenie'
  },
  [CA_EAI_REMOVE_DEVICE]: {
    DEVICE_REMOVAL_NOT_ALLOWED: 'Nemáte právo odstrániť dané zariadenie'
  },
  [CA_EAI_CHANGE_DEVICE_GDS]: {
    CHANGE_DEVICE_GDS_NOT_ALLOWED:
      'Nemáte právo zmeniť priradenie komunikačnej brány danému zariadeniu'
  },
  [CA_EAI_EDIT_DEVICE_CHARACTERISTICS]: {
    EDIT_DEVICE_CHARACTERISTICS_NOT_ALLOWED:
      'Nemáte právo upravovať charakteristiky danému zariadeniu'
  },
  [CA_EAI_CREATE_DEVICE_CHARACTERISTIC_GROUP]: {
    CREATE_DEVICE_CHARACTERISTIC_GROUP_NOT_ALLOWED:
      'Nemáte právo vytvoriť skupiny vlastností danému zariadeniu'
  },
  [CA_EAI_DELETE_DEVICE_CHARACTERISTIC_GROUP]: {
    DELETE_DEVICE_CHARACTERISTIC_GROUP_NOT_ALLOWED:
      'Nemáte právo odzmazať skupinu vlastností danému zariadeniu'
  },
  [CA_EAI_CREATE_DEVICE]: {
    CHOSEN_DEVICE_OOM_NOT_ALLOWED:
      'Nemáte právo vytvoriť zariadenie pre zvolené odberné miesto'
  },
  /* DEVICES */

  /* DELIVERY CONTRACT */
  [CA_EAI_CREATE_DELIVERY_CONTRACT]: {
    CURRENT_CONTRACTING_PARTY_NOT_INCLUDED:
      'V kontrakte musí figurovať zmluvná strana účastník trhu pod ktorým ste aktuálne prihlásený'
  },
  /* DELIVERY CONTRACT */

  /* PRODUCTION PLANNING */
  [CA_DISP_CREATE_DEVICE_PRODUCTION_PLAN]: {
    PRODUCTION_DATE_OVERDUE:
      'Plán produkcie pre uzatvorený obchodný deň nie je možné vytvoriť.',
    PLAN_ALREADY_EXISTS: 'Plán produkcie pre tento obchodný deň už existuje.'
  },
  [CA_DISP_EDIT_DEVICE_PRODUCTION_PLAN]: {
    PRODUCTION_DATE_OVERDUE:
      'Plán produkcie pre uzatvorený obchodný deň už nie je možné editovať.'
  },
  [CA_DISP_CONFIRM_DEVICE_PRODUCTION_PLAN]: {
    PRODUCTION_DATE_OVERDUE:
      'Plán produkcie pre uzatvorený obchodný deň už nie je možné potvrdiť.',
    PRODUCTION_PLAN_LIFECYCLE_VIOLATION:
      'Nepovolený prechod stavu produkčného plánu.',
    DEVICE_NOT_INSTALLED: 'Zariadenie nie je nainštalované.'
  },
  [CA_DISP_PROPAGATE_DEVICE_PRODUCTION_PLAN]: {
    PRODUCTION_DATE_OVERDUE:
      'Plán produkcie pre uzatvorený obchodný deň už nie je možné propagovať.',
    PRODUCTION_PLAN_LIFECYCLE_VIOLATION:
      'Nepovolený prechod stavu produkčného plánu.',
    DEVICE_NOT_INSTALLED: 'Zariadenie nie je nainštalované.',
    GDS_PLANNING_HORIZON_EXCEEDED:
      'Produkciu je možné naplánovať maximálne 6 dní do budúcnosti.'
  },
  [CA_DISP_COPY_DEVICE_PRODUCTION_PLAN]: {
    TARGET_PRODUCTION_DAY_NOT_IN_FUTURE:
      'Cieľový obchodný deň musí byť v budúcnosti.',
    CREATION_OF_PRODUCTION_PLAN_NOT_ALLOWED:
      'Nie ste oprávnený kopírovať plán produkcie na zvolené zariadenie.',
    PRODUCTION_PLAN_PERIODS_MISMATCH:
      'Zdrojový a cieľový obchodný deň musia mať rovnaký počet obchodných periód.',
    PRODUCTION_PLAN_ALREADY_EXISTS:
      'Vo vybranom obchodnom dni alebo rozsahu dní už existuje plán produkcie.'
  },
  [CA_DISP_CREATE_DAILY_DIAGRAM]: {
    DAILY_DIAGRAM_ALREADY_EXISTS:
      'Denný diagram pre tento obchodný deň už existuje.',
    DAILY_DIAGRAM_REGISTRATION_DEADLINE_OVERDUE:
      'Denný diagram pre uzatvorený obchodný deň nie je možné vytvoriť.',
    NO_PRODUCTION_PLAN_REVISION_PROVIDED:
      'Je potrebné vytvoriť aspoň jednu revíziu plánu produkcie zariadenia v tejto bilančnej skupine.',
    NO_VALID_PRODUCTION_PLAN_REVISION_PROVIDED:
      'Je potrebné potvrdiť aspoň jednu revíziu plánu produkcie zariadenia v tejto bilančnej skupine.',
    PRODUCTION_PLAN_REVISION_NOT_EXISTS:
      'Neplatná požiadavka na úpravu denného diagramu.',
    PRODUCTION_PLAN_AND_DAILY_DIAGRAM_DATE_MISMATCH:
      'Neplatná požiadavka na úpravu denného diagramu.',
    ONLY_ONE_PRODUCTION_PLAN_REV_PER_DEVICE_ALLOWED:
      'Neplatná požiadavka na úpravu denného diagramu.',
    INVALID_DEVICE_PRODUCTION_PLAN:
      'Neplatná požiadavka na úpravu denného diagramu.',
    MISSING_NOMINATION_PERIOD_OR_VALUE:
      'Neplatná požiadavka na úpravu denného diagramu.'
  },
  [CA_DISP_EDIT_DAILY_DIAGRAM]: {
    DAILY_DIAGRAM_REGISTRATION_DEADLINE_OVERDUE:
      'Denný diagram pre uzatvorený obchodný deň nie je možné editovať.',
    NO_PRODUCTION_PLAN_REVISION_PROVIDED:
      'Neplatná požiadavka na úpravu denného diagramu.',
    NO_VALID_PRODUCTION_PLAN_REVISION_PROVIDED:
      'Neplatná požiadavka na úpravu denného diagramu.',
    PRODUCTION_PLAN_REVISION_NOT_EXISTS:
      'Neplatná požiadavka na úpravu denného diagramu.',
    PRODUCTION_PLAN_AND_DAILY_DIAGRAM_DATE_MISMATCH:
      'Neplatná požiadavka na úpravu denného diagramu.',
    ONLY_ONE_PRODUCTION_PLAN_REV_PER_DEVICE_ALLOWED:
      'Neplatná požiadavka na úpravu denného diagramu.',
    INVALID_DEVICE_PRODUCTION_PLAN:
      'Neplatná požiadavka na úpravu denného diagramu.',
    MISSING_NOMINATION_PERIOD_OR_VALUE:
      'Neplatná požiadavka na úpravu denného diagramu.'
  },
  [CA_DISP_VALIDATE_DAILY_DIAGRAM]: {
    DAILY_DIAGRAM_VALIDATION_FOR_BAL_GRP_NOT_ALLOWED:
      'Nie ste oprávnený pracovať s denným diagramom tejto bilančnej skupiny.'
  },
  [CA_DISP_ACCEPT_DAILY_DIAGRAM]: {
    DAILY_DIAGRAM_INVALID_PROPAGATION_STATUS:
      'Nepovolený prechod stavu denného diagramu.',
    DAILY_DIAGRAM_ACCEPT_FOR_BAL_GRP_NOT_ALLOWED:
      'Nie ste oprávnený pracovať s denným diagramom tejto bilančnej skupiny.'
  },
  [CA_DISP_EXPORT_DAILY_DIAGRAM]: {
    DAILY_DIAGRAM_INVALID_PROPAGATION_STATUS:
      'Nepovolený prechod stavu denného diagramu.',
    DAILY_DIAGRAM_EXPORT_FOR_BAL_GRP_NOT_ALLOWED:
      'Nie ste oprávnený pracovať s denným diagramom tejto bilančnej skupiny.'
  },
  [CA_DISP_SUBMIT_DAILY_DIAGRAM_REVISION]: {
    DAILY_DIAGRAM_INVALID_PROPAGATION_STATUS:
      'Nepovolený prechod stavu denného diagramu.',
    DAILY_DIAGRAM_INVALID_SUBMISSION_DATE:
      'Denný diagram pre uzatvorený obchodný deň nie je možné editovať.',
    DAILY_DIAGRAM_CORRECTION_DEADLINE_OVERDUE:
      'Denný diagram pre uzatvorený obchodný deň nie je možné editovať.'
  },
  /* PRODUCTION PLANNING */

  /* OPERATION CALENDAR */
  [CA_DISP_CREATE_OPERATION_EVENT]: {
    CREATE_OPERATION_EVENT_FOR_OPERATION_CALENDAR_NOT_ALLOWED:
      'Nie ste oprávnený pridávat udalosti zvoleného zariadenia.',
    OPERATION_EVENT_END_MUST_BE_AFTER_START:
      'Čas konca udalosti musí nasledovať po začiatku udalosti.',
    OPERATION_EVENT_START_NOT_IN_FUTURE:
      'Začiatok udalosti musí byť v budúcnosti.'
  },
  [CA_DISP_EDIT_OPERATION_EVENT]: {
    EDIT_OPERATION_EVENT_NOT_ALLOWED:
      'Nie ste oprávnený upravovať udalosti zvoleného zariadenia.',
    EDIT_OF_CANCELLED_EVENT_NOT_ALLOWED: 'Nemožno editovať zrušenú udalosť.',
    EDIT_OF_COMPLETED_EVENT_END_NOT_ALLOWED:
      'Nie je možné upravovať čas konca ukončenej udalosti.',
    EDIT_OF_COMPLETED_EVENT_START_NOT_ALLOWED:
      'Nie je možné upravovať čas začiatku ukončenej udalosti.',
    EDIT_OF_IN_PROGRESS_EVENT_START_NOT_ALLOWED:
      'Nie je možné upraviť čas začiatku prebiehajúcej udalosti.',
    OPERATION_EVENT_END_MUST_BE_AFTER_START:
      'Čas konca udalosti musí nasledovať po začiatku udalosti.',
    OPERATION_EVENT_START_NOT_IN_FUTURE:
      'Začiatok udalosti musí byť v budúcnosti.',
    OPERATION_EVENT_END_NOT_IN_FUTURE:
      'Nie je možné upraviť čas konca udalosti do minulosti.'
  },
  [CA_DISP_CANCEL_OPERATION_EVENT]: {
    OPERATION_EVENT_CANCELLATION_NOT_ALLOWED:
      'Nie ste oprávnený rušiť udalosti zvoleného zariadenia.',
    OPERATION_EVENT_ALREADY_CANCELED: 'Udalosť už bola zrušená.'
  },
  [CA_DISP_DELETE_OPERATION_EVENT]: {
    OPERATION_EVENT_DELETION_NOT_ALLOWED:
      'Nie ste oprávnený mazať udalosti zvoleného zariadenia.'
  },
  /* OPERATION CALENDAR */

  /* RESERVED CAPACITY */
  [CA_DISP_ACCEPT_RESERVED_CAPACITY_GUARDING_ACTION]: {
    GUARDING_ACTION_ACCEPTANCE_NOT_ALLOWED:
      'Nemáte právo akceptovať dané opatrenie',
    GUARDING_ACTION_VALIDITY_EXPIRED:
      'Opatrenie nad ktorým sa snažíte vykonať akciu je expirované',
    GUARDING_ACTION_UPDATE_REQUIRES_ISSUED_STATE:
      'Opatrenie musí byť v stave “Navrhnuté“ k vykonaniu danej operácie',
    GUARDING_ACTION_HAS_STARTED:
      'Nie je možné akceptovať opatrenie, ktorého čas začiatku je v minulosti'
  },
  [CA_DISP_REJECT_RESERVED_CAPACITY_GUARDING_ACTION]: {
    GUARDING_ACTION_REJECT_NOT_ALLOWED: 'Nemáte právo zamietnuť dané opatrenie',
    GUARDING_ACTION_VALIDITY_EXPIRED:
      'Opatrenie nad ktorým sa snažíte vykonať akciu je expirované',
    GUARDING_ACTION_UPDATE_REQUIRES_ISSUED_STATE:
      'Opatrenie musí byť v stave “Navrhnuté“ k vykonaniu danej operácie'
  }
  /* RESERVED CAPACITY */
};
